import { useEffect } from 'react';
import useModal from 'hooks/useModal';
import { getErrorModalOptions } from './getErrorModalOptions';
import { LatestRef } from './types';
import * as codes from './errorCodes';

export function useAmendmentErrorFlow(ref: LatestRef) {
  const { showModal } = useModal();

  const { errorCode } = ref.current;

  useEffect(() => {
    // If not in error state, do nothing
    if (!errorCode) return;

    // display modal
    if (errorCode !== codes.INVENTORY_UNAVAILABLE) {
      showModal(getErrorModalOptions(errorCode));
    }
  }, [ref, showModal, errorCode]);
}
